// src/pages/Datenschutz.js

import React from 'react';
import { Container, Typography, Box, Paper, AppBar, Toolbar, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
      {/* Navigation */}
      <AppBar position="sticky" elevation={0} sx={{ bgcolor: '#1a365d' }}>
        <Toolbar>
          <Typography 
            variant="h6" 
            sx={{ 
              flexGrow: 1, 
              fontWeight: 700,
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              cursor: 'pointer'
            }}
            onClick={() => navigate('/')}
          >
            <AccountBalanceIcon sx={{ color: '#00bcd4' }} /> immo-automation
          </Typography>
          <Button 
            onClick={() => navigate('/')}
            sx={{ color: 'white' }}
          >
            Zurück zur Startseite
          </Button>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md" sx={{ py: 8 }}>
        <Paper elevation={0} sx={{ p: 6, borderRadius: 3, border: '2px solid #e2e8f0' }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 4, color: '#1a365d' }}>
            Datenschutzerklärung
          </Typography>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              1. Datenschutz auf einen Blick
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen 
              Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit 
              denen Sie persönlich identifiziert werden können.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              2. Datenerfassung auf dieser Website
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, color: '#1a365d' }}>
              Wer ist verantwortlich für die Datenerfassung auf dieser Website?
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
              können Sie dem Impressum dieser Website entnehmen.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              3. Allgemeine Hinweise und Pflichtinformationen
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, color: '#1a365d' }}>
              Datenschutz
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen 
              Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser 
              Datenschutzerklärung. Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener 
              Daten möglich.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              4. Datenerfassung auf dieser Website
            </Typography>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1, color: '#1a365d' }}>
              Cookies
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Textdateien und 
              richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer 
              einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              5. Analyse-Tools und Werbung
            </Typography>
            <Typography variant="body1" sx={{ mb: 2, color: '#64748b', lineHeight: 1.8 }}>
              Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden. Das geschieht 
              vor allem mit sogenannten Analyseprogrammen. Detaillierte Informationen zu diesen Analyseprogrammen 
              finden Sie in der folgenden Datenschutzerklärung.
            </Typography>
          </Box>

          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              6. Ihre Rechte
            </Typography>
            <Typography variant="body1" sx={{ mb: 1, color: '#64748b', lineHeight: 1.8 }}>
              Sie haben jederzeit das Recht:
            </Typography>
            <Box component="ul" sx={{ pl: 3, color: '#64748b' }}>
              <li>Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten</li>
              <li>Berichtigung unrichtiger personenbezogener Daten zu verlangen</li>
              <li>Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
              <li>Einschränkung der Datenverarbeitung zu verlangen</li>
              <li>Widerspruch gegen die Verarbeitung Ihrer Daten einzulegen</li>
              <li>Datenübertragbarkeit zu fordern</li>
            </Box>
          </Box>

          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2, color: '#1a365d' }}>
              7. SSL- bzw. TLS-Verschlüsselung
            </Typography>
            <Typography variant="body1" sx={{ color: '#64748b', lineHeight: 1.8 }}>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, 
              wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine 
              SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die 
              Adresszeile des Browsers von „http://" auf „https://" wechselt.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Datenschutz;
